/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {SnackbarContent, useSnackbar} from 'notistack';
import {hasHideViewEventCTA} from '@ion/applications/src/pages/admin/notifications/NotificationUtils';
import {
  NotificationCard,
  NotificationCardType
} from '@ion/dls/src/notifications/NotificationCard';
import {toggleThemeStyle} from '@ion/dls/src/theme/helpers';
import Features, {
  hasHistoryAccess,
  hasTrackingPageAccess
} from '@/security/Features';
import ViewEventCta from './ViewEventCta';

const useStyles = makeStyles((theme) => ({
  root : toggleThemeStyle({
    minHeight                      : '136px',
    width                          : '414px',
    maxWidth                       : '414px',
    [theme.breakpoints.down('sm')] : {
      maxWidth : 'none',
      width    : '100%'
    }
  }, {
    width                          : '456px',
    maxWidth                       : '456px',
    minHeight                      : '112px',
    [theme.breakpoints.down('sm')] : {
      width    : '100%',
      maxWidth : 'none'
    }
  })
}));

export const NotificationAlert = React.forwardRef(
  (
    {
      id,
      toastId,
      type,
      text,
      subText,
      read,
      timeStamp,
      notification,
      isUrgent,
      onMoreClick,
      onLessClick,
      onReviewClick,
      onDoubleClick,
      moreInfoLoading,
      showMoreInfo,
      onToastRemoved
    }: NotificationCardType,
    ref
  ) => {
    const classes            = useStyles();
    const {closeSnackbar}    = useSnackbar();
    const hasEventAccess     = hasHistoryAccess();
    const isHideViewEventCta = !hasEventAccess || hasHideViewEventCTA(type);

    function handleDismiss() {
      closeSnackbar(id);
      onToastRemoved(toastId);
    }
    return (
      <SnackbarContent ref={ref}>
        <div className={classes.root}>
          <NotificationCard type={type}
            isToast
            id={toastId}
            text={text}
            read={read}
            subText={subText}
            isHideViewEventCta={isHideViewEventCta}
            timeStamp={timeStamp}
            notification={notification}
            isUrgent={isUrgent}
            hasAccessToEntiry={hasTrackingPageAccess()}
            viewEventCta={<ViewEventCta notification={notification} />}
            onCloseClick={handleDismiss}
            onDoubleClick={onDoubleClick}
            onMoreClick={onMoreClick}
            onLessClick={onLessClick}
            onReviewClick={onReviewClick}
            moreInfoLoading={moreInfoLoading}
            showMoreInfo={showMoreInfo} />
        </div>
      </SnackbarContent>
    );
  }
);

export default NotificationAlert;
